import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import FormatDownload from "../../../components/format-download";
import {
  createPart,
  deletePart,
  exportPart,
  fetchAllPart,
  fetchAllRack,
  importPart,
  updatePart,
} from "../../../resources/PartResource";
import { getLocalAuth } from "../../../utils/AuthUtils";
import { showSuccessToast } from "../../../utils/GlobalToast";
import ErrorNotFound from "../../errors/Error";

function Part() {
  const values = getLocalAuth();
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter((data) => {
    return data.code === "Part";
  });

  let dataRead =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
        return data.code === "Read";
      });

  let dataCreate =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
        return data.code === "Create";
      });

  let dataUpdate =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
        return data.code === "Update";
      });

  let dataDelete =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
        return data.code === "Delete";
      });

  let dataImport =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
        return data.code === "Import";
      });

  let dataExport =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
        return data.code === "Export";
      });

  const [dataPart, setDataPart] = useState([]);

  const [partNumber, setPartNumber] = useState("");
  const [name, setName] = useState("");
  const [rack, setRack] = useState("");
  const [standardStock, setStandardStock] = useState(0);
  const [optionsRack, setOptionsRack] = useState([]);

  const [idEdit, setIdEdit] = useState(null);
  const [nameEdit, setNameEdit] = useState("");
  const [standardStockEdit, setStandardStockEdit] = useState(0);
  const [rackEdit, setRackEdit] = useState("");

  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState("");
  const [isErrorEdit, setIsErrorEdit] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");
  const [isErrorImport, setIsErrorImport] = useState(false);
  const [errorImport, setErrorImport] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  const fetchPart = () => {
    fetchAllPart()
      .then((res) => {
        setDataPart(res.data);
      })
      .catch((err) => {
        setDataPart([]);
      });
  };

  const fetchRack = () => {
    fetchAllRack()
      .then((res) => {
        const data = res.map((e) => {
          return { value: e.id, label: e.name };
        });
        setOptionsRack(data);
      })
      .catch((err) => console.log("Gagal Fetch Data Rack: ", err));
  };

  useEffect(() => {
    fetchRack();
    fetchPart();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    postPart(partNumber, name, rack, standardStock);
  };

  const postPart = (partNumber, name, rack, standardStock) => {
    setIsLoading(true);
    createPart(partNumber, name, rack, standardStock)
      .then((res) => {
        setIsLoading(false);
        setIsError(false);
        showSuccessToast("Success Added Part!");
        setShowAddModal(false);
        setPartNumber("");
        setName("");
        fetchPart();
      })
      .catch((err) => {
        setIsLoading(false);
        setError(
          typeof err === "undefined"
            ? "There was an error checking your connection or input"
            : err
        );
        setIsError(true);
      });
  };

  const handleImport = (e) => {
    e.preventDefault();

    postImportPart(selectedFile);
  };

  const getExportPart = () => {
    exportPart()
      .then((res) => { })
      .catch((err) => {
        console.log(err);
      });
  };

  const postImportPart = (selectedFile) => {
    setIsLoading(true);
    importPart(selectedFile)
      .then((res) => {
        setIsLoading(false);
        setIsErrorImport(false);
        showSuccessToast("Success Import Part!");
        setShowImportModal(false);
        fetchPart();
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorImport(err);
        setIsErrorImport(true);
      });
  };

  const handleData = (data) => {
    setIdEdit(data.id);
    setNameEdit(data.name);
    setRackEdit(data.rack_id);
    setStandardStockEdit(
      data.standart_stock === null ? 0 : data.standart_stock
    );
  };

  const handleDelete = () => {
    setIsLoading(true);
    deletePart(idEdit)
      .then((res) => {
        setIsLoading(false);
        setIsErrorDelete(false);
        showSuccessToast("Success Deleted Part!");
        setShowDeleteModal(false);
        fetchPart();
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorDelete(err);
        setIsErrorDelete(true);
      });
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    updatePart(idEdit, nameEdit, standardStockEdit, rackEdit)
      .then((res) => {
        setIsLoading(false);
        setIsErrorEdit(false);
        showSuccessToast("Success Updated Part!");
        setShowEditModal(false);
        fetchPart();
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorEdit(err);
        setIsErrorEdit(true);
      });
  };

  const columns = [
    {
      name: "No",
      cell: (row, index) => index + 1,
      width: "60px",
    },
    {
      name: "Part No",
      selector: (row) => row.part_number,
      sortable: true,
    },
    {
      name: "Part Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Rack Location",
      selector: (row) => row.rack_name,
      sortable: true,
    },
    {
      name: "Standard Stock",
      selector: (row) =>
        row.standart_stock === null ? "-" : `${row.standart_stock} pcs`,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) =>
        row.created_at === null
          ? "-"
          : format(row.created_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
    },
    {
      name: "Updated At",
      selector: (row) =>
        row.updated_at === null
          ? "-"
          : format(row.updated_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          {dataDelete.length === 0 ? (
            <div></div>
          ) : !dataDelete[0].is_active ? (
            <div></div>
          ) : (
            <button
              type="button"
              style={{ marginRight: "8px" }}
              className="btn btn-danger"
              onClick={() => {
                handleData(row);
                setShowDeleteModal(true);
              }}
            >
              Delete
            </button>
          )}
          <div
            className={`modal fade ${showDeleteModal ? "show" : ""}`}
            style={{
              display: showDeleteModal ? "block" : "none",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete this data?</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                    aria-label="Close"
                  ></button>
                </div>
                {isErrorDelete ? (
                  <div
                    style={{
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      paddingTop: "16px",
                      paddingBottom: "0px",
                    }}
                  >
                    <div
                      className="alert alert-danger alert-dismissible fade show"
                      role="alert"
                    >
                      {errorDelete}
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                        onClick={() => setIsErrorDelete(false)}
                      ></button>
                    </div>
                  </div>
                ) : null}
                <div className="modal-body">
                  {`You will delete ${nameEdit}`}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                  {!isLoading ? (
                    <button
                      type="submit"
                      className="btn btn-danger"
                      onClick={() => handleDelete()}
                    >
                      Delete
                    </button>
                  ) : (
                    <button className="btn btn-danger" type="button" disabled>
                      {" "}
                      <span
                        style={{ marginRight: "4px" }}
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loading...
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {dataUpdate.length === 0 ? (
            <div></div>
          ) : !dataUpdate[0].is_active ? (
            <div></div>
          ) : (
            <button
              type="button"
              className="btn btn-info"
              onClick={() => {
                handleData(row);
                setShowEditModal(true);
              }}
            >
              View
            </button>
          )}
          <div
            className={`modal fade ${showEditModal ? "show" : ""}`}
            style={{
              display: showEditModal ? "block" : "none",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Master Data Part</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowEditModal(false)}
                    aria-label="Close"
                  ></button>
                </div>
                {isErrorEdit ? (
                  <div
                    style={{
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      paddingTop: "16px",
                      paddingBottom: "0px",
                    }}
                  >
                    <div
                      className="alert alert-danger alert-dismissible fade show"
                      role="alert"
                    >
                      {errorEdit}
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                        onClick={() => setIsErrorEdit(false)}
                      ></button>
                    </div>
                  </div>
                ) : null}
                <div className="modal-body">
                  <form onSubmit={handleEdit}>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Name</label>
                      <input
                        required
                        type="text"
                        value={nameEdit}
                        onChange={(e) => setNameEdit(e.target.value)}
                        className="form-control"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Standard Stock
                      </label>
                      <input
                        required
                        type="number"
                        value={standardStockEdit}
                        min={0}
                        onChange={(e) => setStandardStockEdit(e.target.value)}
                        className="form-control"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Rack Location
                      </label>
                      <select
                        required
                        type="text"
                        value={rackEdit}
                        onChange={(e) => setRackEdit(e.target.value)}
                        className="form-control"
                      >
                        <option></option>
                        {optionsRack.map((e, index) => {
                          return (
                            <option key={index} value={e.value}>
                              {e.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowEditModal(false);
                          setRackEdit("");
                        }}
                      >
                        Cancel
                      </button>
                      {!isLoading ? (
                        <button type="submit" className="btn btn-info">
                          Save
                        </button>
                      ) : (
                        <button className="btn btn-info" type="button" disabled>
                          {" "}
                          <span
                            style={{ marginRight: "4px" }}
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div>
      {dataRead.length === 0 ? (
        <ErrorNotFound />
      ) : !dataRead[0].is_active ? (
        <ErrorNotFound />
      ) : (
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row">
                    <div className="col">
                      <h4 className="mb-0">Master Data Part</h4>
                    </div>
                    <div className="col">
                      <div className="text-end">
                        {dataCreate.length === 0 ? (
                          <div></div>
                        ) : !dataCreate[0].is_active ? (
                          <div></div>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-info ms-auto radius-10"
                            onClick={() => {
                              setShowAddModal(true);
                            }}
                            style={{ marginRight: "8px" }}
                          >
                            <i className="bx bx-plus"></i> Part
                          </button>
                        )}
                        {dataImport.length === 0 ? (
                          <div></div>
                        ) : !dataImport[0].is_active ? (
                          <div></div>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-success ms-auto radius-10"
                            onClick={() => {
                              setShowImportModal(true);
                            }}
                            style={{ marginRight: "8px" }}
                          >
                            <i className="bx bx-import"></i> Import
                          </button>
                        )}
                        {dataExport.length === 0 ? (
                          <div></div>
                        ) : !dataExport[0].is_active ? (
                          <div></div>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary ms-auto radius-10"
                            onClick={() => {
                              getExportPart();
                            }}
                          >
                            <i className="bx bx-export"></i> Export
                          </button>
                        )}
                      </div>
                    </div>
                    <div
                      className={`modal fade ${showImportModal ? "show" : ""}`}
                      style={{
                        display: showImportModal ? "block" : "none",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                      }}
                    >
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => {
                                setShowImportModal(false);
                              }}
                              aria-label="Close"
                            ></button>
                          </div>
                          {isErrorImport ? (
                            <div
                              style={{
                                paddingLeft: "16px",
                                paddingRight: "16px",
                                paddingTop: "16px",
                                paddingBottom: "0px",
                              }}
                            >
                              <div
                                className="alert alert-danger alert-dismissible fade show"
                                role="alert"
                              >
                                {errorImport}
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="alert"
                                  aria-label="Close"
                                  onClick={() => setIsErrorImport(false)}
                                ></button>
                              </div>
                            </div>
                          ) : null}
                          <div className="modal-body">
                            <FormatDownload url={'/Lokasi Penempatan Dies.xlsx'} />
                            <form onSubmit={handleImport}>
                              <div className="mb-3">
                                <input
                                  required
                                  className="form-control"
                                  type="file"
                                  id="formFile"
                                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                  onChange={(e) =>
                                    setSelectedFile(e.target.files[0])
                                  }
                                />
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={() => {
                                    setShowImportModal(false);
                                  }}
                                >
                                  Cancel
                                </button>
                                {!isLoading ? (
                                  <button
                                    type="submit"
                                    className="btn btn-info"
                                  >
                                    Submit
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-info"
                                    type="button"
                                    disabled
                                  >
                                    {" "}
                                    <span
                                      style={{ marginRight: "4px" }}
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Loading...
                                  </button>
                                )}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`modal fade ${showAddModal ? "show" : ""}`}
                      style={{
                        display: showAddModal ? "block" : "none",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                      }}
                    >
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Master Data Part</h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => {
                                setShowAddModal(false);
                              }}
                              aria-label="Close"
                            ></button>
                          </div>
                          {isError ? (
                            <div
                              style={{
                                paddingLeft: "16px",
                                paddingRight: "16px",
                                paddingTop: "16px",
                                paddingBottom: "0px",
                              }}
                            >
                              <div
                                className="alert alert-danger alert-dismissible fade show"
                                role="alert"
                              >
                                {error}
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="alert"
                                  aria-label="Close"
                                  onClick={() => setIsError(false)}
                                ></button>
                              </div>
                            </div>
                          ) : null}
                          <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                              <div className="mb-3">
                                <label className="form-label fw-bold">
                                  Part Number
                                </label>
                                <input
                                  required
                                  type="text"
                                  value={partNumber}
                                  onChange={(e) =>
                                    setPartNumber(e.target.value)
                                  }
                                  className="form-control"
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">
                                  Name
                                </label>
                                <input
                                  required
                                  type="text"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  className="form-control"
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">
                                  Rack Location
                                </label>
                                <select
                                  required
                                  type="text"
                                  value={rack}
                                  onChange={(e) => setRack(e.target.value)}
                                  className="form-control"
                                >
                                  <option></option>
                                  {optionsRack.map((e, index) => {
                                    return (
                                      <option key={index} value={e.value}>
                                        {e.label}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">
                                  Standard Stock
                                </label>
                                <input
                                  required
                                  type="number"
                                  value={standardStock}
                                  onChange={(e) =>
                                    setStandardStock(e.target.value)
                                  }
                                  min={0}
                                  className="form-control"
                                />
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={() => {
                                    setShowAddModal(false);
                                    setRack("");
                                  }}
                                >
                                  Cancel
                                </button>
                                {!isLoading ? (
                                  <button
                                    type="submit"
                                    className="btn btn-info"
                                  >
                                    Submit
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-info"
                                    type="button"
                                    disabled
                                  >
                                    {" "}
                                    <span
                                      style={{ marginRight: "4px" }}
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Loading...
                                  </button>
                                )}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="table-responsive">
                  <DataTable columns={columns} data={dataPart} pagination />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Part;
